<template>
  <div id="container">
    <MobilityMatcher id="mobilityMatcher"/>
  </div>
</template>
<script>
import MobilityMatcher from '@/components/MobilityMatcher.vue';

export default {
  name: 'app',
  components: {
    MobilityMatcher,
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "VWHead-Regular";
  src: url("./assets/fonts/VWHead-Regular.otf");
}
@font-face {
  font-family: "VWHead-Bold";
  src: url("./assets/fonts/VWHead-Bold.otf");
}
@font-face {
  font-family: "VWHead-Light";
  src: url("./assets/fonts/VWHead-Light.otf");
}
@font-face {
  font-family: "VWText-Regular";
  src: url("./assets/fonts/VWText-Regular.otf");
}
@font-face {
  font-family: "VWText-Bold";
  src: url("./assets/fonts/VWText-Bold.otf");
}
@font-face {
  font-family: "VWText-Light";
  src: url("./assets/fonts/VWText-Light.otf");
}
body, html {
  background-color: rgba(223, 228, 232, 0.25);
  font-family: 'VWText-Regular', 'Avenir', Helvetica, Arial, sans-serif;
}
#mobilityMatcher {
  font-family: 'VWText-Light', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}
</style>
